export default __webpack_public_path__ + "images/assets/56684f9fa680ddec124e95dc943ac3aa.svg";